import { Button, Col, Collapse, Row, Spin, Table } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import CustomTypography from "../../common/CustomTypography";
import { MinusOutlined, PlusOutlined, StarFilled } from "@ant-design/icons";
import styles from "./bouncedcheques.module.scss";
import CustomAmountText from "../../common/CustomAmountText";

const BouncedChequesPage = () => {
  const {
    bouncedchequesDetails: bouncedchequesData,
  } = useSelector(({ bouncedcheques }) => bouncedcheques);

  const { selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <AccordionWithTable selectedAccountId={selectedAccountId} transactionData={bouncedchequesData} />
      </Col>
    </Row>
  );
};

const AccordionWithTable = ({ transactionData, selectedAccountId, tableProps, ...restProps }) => {

  const { bouncedchequesLoading: loading, bouncedchequesError: error } = useSelector(({ bouncedcheques }) => bouncedcheques);

  const panelStyle = {
    marginBottom: 16,
    background: "white",
    borderRadius: "6px",
    border: "1px solid #C9EEF2",
    color: "#000000E0"
  };

  
  const collapseItems = Object.keys(transactionData)?.map((item, index) => {

    const commonColumns = [
      {
        title: "Txn Date", dataIndex: "date", key: "date", className: styles.colStyle
      },
      {
        title: "Particulars", dataIndex: "particular", key: "particular", width: 180, className: styles.colStyle
      },
      {
        title: "Cheque number", dataIndex: "chequeNumber", key: "chequeNumber", className: styles.colStyle
      },
      {
        title: "Debit (₹)", dataIndex: "amount", key: "amount", className: styles.colStyle, render: (text, record) => record.type === 'DB' ? <CustomAmountText value={record.amount} /> : ''
      },
      {
        title: "Credit (₹)", dataIndex: "amount", key: "amount", className: styles.colStyle, render: (text, record) => record.type === 'CR' ? <CustomAmountText value={record.amount} /> : '' 
      },
      {
        title: "Balance (₹)", dataIndex: "balance", key: "balance", className: styles.colStyle, render: (text, record) => <CustomAmountText value={record.balance} />
      },
      {
        title: "Tags", dataIndex: "tags", key: "tags", className: styles.colStyle
      },
    ];


    if(selectedAccountId === "all"){
      commonColumns.unshift({
        title: "Bank Account",
        dataIndex: "accountDetails",
        key: "accountDetails",
        width: 190,
        render: value => (
          <>
          <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
          {`${value?.bankAbbreviation} - ${value?.accountNumber.slice(8,12)} - ${value?.accountType}`}
          </>
        )
      })
    }

    const getLables = (keyLable) => {
      if(keyLable === 'outwardChequeTransactions'){
        return `Outwards Cheques (${transactionData.outwardChequeTransactions.length})`
      } else if( keyLable === 'inwardChequeTransactions'){
        return `Inwards Cheques (${transactionData.inwardChequeTransactions.length})`
      } else {
        return `Same Day Cheques (${transactionData.sameDayChequeTransactions.length})`
      }
    }
    const getDataSource = (keyLable) => {
      if(keyLable === 'outwardChequeTransactions'){
        return transactionData.outwardChequeTransactions
      } else if( keyLable === 'inwardChequeTransactions'){
        return transactionData.inwardChequeTransactions
      } else {
        return transactionData.sameDayChequeTransactions
      }
    }



    const getRowItemNumber = (data) => {
      return data?.length;
    };

    return {
      key: index.toString(),
      label: <CustomTypography style={{ fontSize: "16px", fontWeight: 500, lineHeight: "24px", color: "#000000E0", fontFamily: "Satoshi" }}>{getLables(item)}</CustomTypography>,
      children: <>
        <Table loading={loading}
          dataSource={getDataSource(item)}
          columns={commonColumns}
          pagination={false}
        />
      </>,
      style: panelStyle,
    };
  });

  const IconWrapper = ({ children }) => {
    return (
      <div style={{ height: "16px", width: "16px", borderRadius: "4px", border: "1px solid #F0F0F0", display: "flex", justifyContent: "center" }}>
        {children}
      </div>
    )
  }

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
        <Spin size="large" />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", flexDirection: "column" }}>
        <CustomTypography style={{ fontSize: "16px", fontWeight: 500, lineHeight: "24px", color: "#000000E0", fontFamily: "Satoshi" }}>Error fetching data</CustomTypography>
        <CustomTypography type={"paragraph"} style={{ fontSize: "10px", fontWeight: 300, lineHeight: "16px", color: "#000000E0", fontFamily: "Satoshi" }}>{error}</CustomTypography>
      </div>
    )
  }

  return (
    <Collapse
      bordered={false}
      // defaultActiveKey={['0']}
      style={{
        background: "#F7F7FC",
      }}
      // accordion
      items={collapseItems}
      expandIcon={({ isActive }) => <IconWrapper>{isActive ? <MinusOutlined /> : <PlusOutlined />}</IconWrapper>}
      {...restProps}
    />
  )
};

export default BouncedChequesPage;
